import { render, staticRenderFns } from "./ResetFriendList.vue?vue&type=template&id=5f23262a&scoped=true&"
import script from "./ResetFriendList.vue?vue&type=script&lang=js&"
export * from "./ResetFriendList.vue?vue&type=script&lang=js&"
import style0 from "./ResetFriendList.vue?vue&type=style&index=0&id=5f23262a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23262a",
  null
  
)

export default component.exports